// pages/LoginPage/LoginPage.js
import React from 'react';
import SignUpForm from '../../components/SignUpForm/SignUpForm';
import Header from '../../components/Header/Header';


const SignUpPage = () => {
  return (
    <div className="signup-page">
         <div className='Header-container'>
            <Header />
        </div>
      <div className="signup-container">
        <SignUpForm />
      </div>
    </div>
  );
};

export default SignUpPage;